import { motion } from 'framer-motion'
import { Progress } from '../ui/Progress'
import { useEffect, useState } from 'react'
import './Loading.css'

export default function Loading() {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const timer = setTimeout(() => {
      setProgress(100)
    }, 500)

    return () => clearTimeout(timer)
  }, [])

  return (
    <motion.div 
      className="loading-screen"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div 
        className="loading-content"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <h1 className="loading-title">
        EVOAXY<span className="gradient-text">.</span>
        </h1>
        <div className="progress-wrapper">
          <Progress value={progress} />
        </div>
      </motion.div>
    </motion.div>
  )
}

